import { useLanguage } from "@/i18n";
import { Reveal, Chapter } from "./shared";

export const Milestones = () => {
  const { t } = useLanguage();
  return (
    <section id="milestones" className="scroll-mt-24 bg-white" data-testid="milestones-section">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-32">
        <Chapter num="07" label={t.milestones.chapter.split("/ ")[1]} />
        <Reveal>
          <h2 data-testid="milestones-heading" className="mt-12 font-display text-3xl font-extrabold tracking-tight text-neutral-950 sm:text-4xl lg:text-5xl">
            {t.milestones.heading}
          </h2>
        </Reveal>
        <div className="mt-16">
          {t.milestones.items.map(([year, title, detail], i) => (
            <Reveal key={year} delay={i * 0.06}>
              <div
                data-testid={`milestone-${year.replace("+", "plus")}`}
                className="group grid items-baseline gap-2 border-t border-neutral-200 py-9 transition-colors duration-500 last:border-b hover:bg-paper sm:grid-cols-12 sm:gap-6 sm:px-4"
              >
                <div className="font-mono text-4xl font-bold tracking-tighter text-neutral-200 transition-colors duration-500 group-hover:text-brand-600 sm:col-span-3 sm:text-5xl">
                  {year}
                </div>
                <h3 className="font-display text-xl font-bold text-neutral-900 sm:col-span-4 sm:text-2xl">{title}</h3>
                <p className="text-sm leading-relaxed text-neutral-500 sm:col-span-5">{detail}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
